import type { SelectSlots as SelectBaseSlots, SelectBaseProps, SelectBaseState } from '@fluentui/react-select';

export type SelectSlots = SelectBaseSlots;

/**
 * Select Props
 */
export type SelectProps = SelectBaseProps;

/**
 * State used in rendering Select
 */
export type SelectState = SelectBaseState & {
  root: {
    /**
     * Data attribute set when the select is disabled.
     */
    'data-disabled'?: string;

    /**
     * Data attribute set when the select is invalid.
     */
    'data-invalid'?: string;
  };
};
